/**
 * Códigos de erro de MÍDIA (arquivo anexado a campanha, agendamento,
 * comunicado...) que atravessam back → front.
 * Padrão: ERR_<DOMÍNIO>_<MOTIVO>.
 */
export const MEDIA_ERRORS = {
  /**
   * 400 — o caminho do arquivo sairia da pasta permitida (#4481). O
   * `mediaPath` vem do banco, gravado a partir do nome do arquivo enviado: um
   * `../` ali levaria a remoção para fora da raiz da empresa.
   */
  INVALID_PATH: "ERR_INVALID_MEDIA_PATH",
} as const;

export type MediaErrorCode = (typeof MEDIA_ERRORS)[keyof typeof MEDIA_ERRORS];
